<template>
  <div class="l_contact_us_faq">
    <div class="container">
      <!-- <div class="header">
        <img src="../assets/img/faq/back.svg" alt="ico_setting" @click="goBack()">
        <p>お問い合わせ</p>
      </div> -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'FAQContact',
  components: {
  },
  created () {
    document.title = 'お問い合わせ'
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'FAQ' })
    }
  }
}
</script>

<style scoped>

.l_contact_us_faq {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}

.l_contact_us_faq .container .header {
  max-width: 100%;
  padding: 18px 0px;
  position: relative;
  border-bottom: 1px solid #eeeeee;
}

.l_contact_us_faq .container .header img {
  position: absolute;
  left: 18px;
}

.l_contact_us_faq .container .header > p {
  font-family: HiraKakuPro-W6;
  font-size: 15px;
  font-weight: bold;
  line-height: 1;
  text-align: center;
}

</style>
